import { classNames } from 'primereact/utils';

export const renderClampedText = (value: unknown, lineClamp: number = 3) => {
  if (value === null || value === undefined) return '';

  const text = String(value);

  // `-webkit-line-clamp` breaks at hyphens before it truncates, which cuts one-line values short.
  if (lineClamp === 1) {
    return (
      <span className="block truncate" title={text}>
        {text}
      </span>
    );
  }

  return (
    <span
      className={classNames('block overflow-hidden')}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: 'vertical',
      }}
      title={text}
    >
      {text}
    </span>
  );
};
